<template>
    <footer class="subfooter">
        <section class="container">
        <center>
                Truckermatching.com is a Twegos  product -  &copy; 2019 
        </center>
        </section>
    </footer>
    
</template>

<script>
import Common from '@/contents/common.json'

export default {
  name: 'SectionSubFooter',
  data () {
    return {
      'data': Common
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/SubFooter.vue